import { render, staticRenderFns } from "./MarketingPoints.vue?vue&type=template&id=2fbd4a79&scoped=true&"
import script from "./MarketingPoints.vue?vue&type=script&lang=ts&"
export * from "./MarketingPoints.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingPoints.vue?vue&type=style&index=0&id=2fbd4a79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd4a79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})
